import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalImage"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  open(event) {
    const src = event.currentTarget.dataset.chatMediaUrlParam
    if (!src || !this.hasModalTarget || !this.hasModalImageTarget) return

    this.modalImageTarget.src = src
    this.modalTarget.hidden = false
  }

  close(event) {
    if (event && event.target !== this.modalTarget && event.target !== this.modalImageTarget) {
      return
    }

    if (this.hasModalTarget) this.modalTarget.hidden = true
    if (this.hasModalImageTarget) this.modalImageTarget.src = ""
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
